import React from 'react';
import { Modal } from '@cbhq/cds-web/overlays/modal/Modal';
import { Button } from '@cbhq/cds-web/buttons/Button';
import { TextBody } from '@cbhq/cds-web/typography';
import { ModalHeader } from '@cbhq/cds-web/overlays/modal/ModalHeader';
import { ModalBody } from '@cbhq/cds-web/overlays/modal/ModalBody';
import { ModalFooter } from '@cbhq/cds-web/overlays/modal/ModalFooter';
import { VStack } from '@cbhq/cds-web/layout';
import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';

// Define the modal content as a constant
const DEVELOPER_MODE_DESCRIPTION = `
  Developer mode enables the testnet network (Base Sepolia) for developer testing.
  Note that you'll need to switch the network in your wallet to Base Sepolia to activate the app on testnet. 
  You can always switch back to Base in your wallet or disable this setting.
`;

type TestnetModeModalProps = {
  visible: boolean;
  onClose: () => void;
};

export function TestnetModeModal({ visible, onClose }: TestnetModeModalProps) {
  const { isPhone, isPhoneLandscape } = useBreakpoints();

  return (
    <Modal
      width={isPhone || isPhoneLandscape ? undefined : 422}
      visible={visible}
      onRequestClose={onClose}
      shouldCloseOnEscPress
      hideDividers
      testID="testnet-mode-modal"
    >
      <ModalHeader title="Developer mode" />
      <ModalBody>
        <VStack alignItems="center" justifyContent="center" width="100%" paddingBottom={2} gap={4}>
          <TextBody as="p" textAlign="center">
            {DEVELOPER_MODE_DESCRIPTION}
          </TextBody>
        </VStack>
      </ModalBody>
      <ModalFooter
        primaryAction={
          <Button
            variant="primary"
            onClick={onClose}
            testID="testnet-mode-modal-close-button"
            block
          >
            Close
          </Button>
        }
      />
    </Modal>
  );
}
